import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { AUTOCALLER_URL } from '@shared/helpers/env';
class CampaignsServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getList(params) {
    return super.getList({ ...params });
  }
  createItem(params) {
    return this.pure_http.post('/campaigns', params);
  }
  addOperator(campaign_id, id) {
    return this.pure_http.post(`/campaigns/${campaign_id}/operators`, id);
  }
  getOperators(campaign_id) {
    return this.pure_http.get(`/campaigns/${campaign_id}/operators`);
  }
  removeOperator(campaign_id, id) {
    return this.pure_http.delete(`/campaigns/${campaign_id}/operators/${id}`);
  }
  dropAsr(campaign_id) {
    return this.pure_http.post(`campaigns/${campaign_id}/drop-asr`);
  }
  getItem(campaign_id) {
    return this.http.get(`/${campaign_id}`);
  }
  editItem(id, params = {}) {
    return this.http.put(`/${id}`, params);
  }
  getCampaignSelect(params = {}) {
    return this.http.get('/select', { params });
  }
}

export const CampaignsService = new CampaignsServiceClass({
  api_version: 1,
  base_url: AUTOCALLER_URL,
  resource: 'campaigns'
});
